import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import Link from "next/link";
import Image from "next/image";

import carouselBGimg01 from "../../assets/images/home/Banner/UPSC-Result-Web-Banner.jpg";
import carouselBGimg12 from "../../assets/images/home/Banner/Interview-webbanner-clickhere.jpg";
import carouselBGimg2 from "../../assets/images/home/Banner/UPSC-State-topper-2024-Web-Banner.jpg";
//import carouselBGimg13 from "../../assets/images/home/Banner/Forestry-Optional-Delhi-Web-Banner.jpg";
import carouselBGimg1 from "../../assets/images/home/Banner/UPSC-CSE-2025-Webbanner.jpg";
import carouselBGimg3 from "../../assets/images/home/Banner/Prefit-and-Prestorming-Web-Banner-ClickHere.jpg";
//import carouselBGimg5 from "../../assets/images/home/Banner/UPSC-GSPCM-Web-Banner-with-button.jpg";
import carouselBGimg6 from "../../assets/images/home/Banner/TNPSC-RESULT-Web-Banner-02-1-2025.jpg";
//import carouselBGimg7 from "../../assets/images/home/Banner/TNPSC-GSPCM-Webbanner-Clickhere-26.jpg";
import carouselBGimg8 from "../../assets/images/home/Banner/Felicitation -web-banner-button.jpg";
import carouselBGimg9 from "../../assets/images/home/Banner/IFS-Result-Webbanner-2024.jpg";


{/* mobile */}
import carouselMBimg01 from "../../assets/images/home/Mob_Banner/UPSC-GSPCM-Mob-Banner-with-Button.jpg";
import carouselMBimg2 from "../../assets/images/home/Mob_Banner/UPSC-State-topper-2024-Mobile-Banner.jpg";
import carouselMBimg12 from "../../assets/images/home/Mob_Banner/Interview-Mobbanner-clickhere.jpg";
//import carouselMBimg13 from "../../assets/images/home/Mob_Banner/Forestry-Optional-Delhi-Mobile-Banner.jpg";
import carouselMBimg1 from "../../assets/images/home/Mob_Banner/UPSC-CSE-2025-Mobbanner.jpg";
import carouselMBimg3 from "../../assets/images/home/Mob_Banner/Prefit-and-Prestorming-Mobile-Banner-Click-Here.jpg";
//import carouselMBimg5 from "../../assets/images/home/Mob_Banner/Toppers-Mobile-Banner-click-here.jpg";
import carouselMBimg6 from "../../assets/images/home/Mob_Banner/TNPSC-RESULT-Mobile-Banner-021-2025.jpg";
//import carouselMBimg7 from "../../assets/images/home/Mob_Banner/TNPSC-GSPCM-Mobbanner-Clickhere-26.jpg";
import carouselMBimg8 from "../../assets/images/home/Mob_Banner/Felicitation-Mob-banner-button.jpg";
import carouselMBimg9 from "../../assets/images/home/Mob_Banner/IFS-Result-2024-Mobile-Banner.jpg";


function slider() {

    const BGimg = [
      //{ quickLoading: false, img: carouselBGimg5,  alt: "carousel", link: "/upsc-admission-anna-nagar/#pregspcm" },
      { quickLoading: false, img: carouselBGimg01, alt: "carousel", link: "/upsc-admission-anna-nagar" },
      { quickLoading: false, img: carouselBGimg12, alt: "carousel", link: "/upsc-interview" },
      { quickLoading: false, img: carouselBGimg3,  alt: "carousel", link: "/upsc-prelims-test-series" },

      //{ quickLoading: false, img: carouselBGimg13, alt: "carousel", link: "/forestry-admission" },
      { quickLoading: false, img: carouselBGimg8,  alt: "carousel", link: "https://www.shankariasacademy.com/blog/felicitation-of-2024-achievers/" },
      { quickLoading: false, img: carouselBGimg9,  alt: "carousel", link: "/upsc-admission-anna-nagar" },
      { quickLoading: false, img: carouselBGimg2,  alt: "carousel", link: "/upsc-admission-anna-nagar" },
   
     
      //{ quickLoading: false, img: carouselBGimg7, alt: "carousel", link: "/tnpsc-admissions" },
      { quickLoading: false, img: carouselBGimg1, alt: "carousel", link: "/upsc-admission-anna-nagar" },
      { quickLoading: false, img: carouselBGimg6, alt: "carousel", link: "/tnpsc-admissions" }
      
       ]

      const MBimg = [
       // { quickLoading: false, img: carouselMBimg5, alt: "carousel", link: "/upsc-admission-anna-nagar/#pregspcm" },
        { quickLoading: false, img: carouselMBimg01, alt: "carousel", link: "/upsc-admission-anna-nagar" },
        { quickLoading: false, img: carouselMBimg12, alt: "carousel", link: "/upsc-interview" }, 
        { quickLoading: false, img: carouselMBimg3, alt: "carousel", link: "/upsc-prelims-test-series" },
        
        //{ quickLoading: false, img: carouselMBimg13, alt: "carousel", link: "/forestry-admission" },
        { quickLoading: false, img: carouselMBimg8, alt: "carousel", link: "https://www.shankariasacademy.com/blog/felicitation-of-2024-achievers/" },
        { quickLoading: false, img: carouselMBimg9, alt: "carousel", link: "/upsc-admission-anna-nagar" },
       
        { quickLoading: false, img: carouselMBimg2, alt: "carousel", link: "/upsc-admission-anna-nagar" },
       // { quickLoading: false, img: carouselMBimg7, alt: "carousel", link: "/tnpsc-admissions" },
        { quickLoading: false, img: carouselMBimg1, alt: "carousel", link: "/upsc-admission-anna-nagar" },
        { quickLoading: false, img: carouselMBimg6, alt: "carousel", link: "/tnpsc-admissions" }
        
        
      ]
  
  return (
    <>
        {/* Carousel large devices*/}
      <div className="container-fluid">
        <div className="row">
          <div className="col px-0 d-none d-md-block">
            <Carousel>
              {BGimg.map((e, index) =>
                <Carousel.Item key={index}>
                  <Link href={e.link} rel="noreferrer">
                    <Image
                      className="carouselimage img-fluid w-100 h-100"
                      src={e.img}
                      alt={e.alt}
                      title="Shankar IAS Academy"
                      loading={e.quickLoading ? "eager" : "lazy"}
                      placeholder="blur"
                    /></Link>
                </Carousel.Item>
              )}
            </Carousel>
          </div>
        </div>
      </div>

      {/* Carousel Mobile devices*/}
      <div className="container-fluid">
        <div className="row">
          <div className="col px-0 d-block d-md-none">
            <Carousel>
              {MBimg.map((e, index) =>
                <Carousel.Item key={index}>
                  <Link href={e.link} rel="noreferrer">
                    <Image
                      className="carouselimage img-fluid"
                      src={e.img}
                      alt={e.alt}
                      title="Shankar IAS Academy"
                      loading={e.quickLoading ? "eager" : "lazy"}
                      placeholder="blur"
                    /></Link>
                </Carousel.Item>
              )}
            </Carousel>
          </div>
        </div>
      </div>

    </>
  )
}

export default slider